export default __webpack_public_path__ + "static/media/ve_2.6617c1ee.mp3";